import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('clientSelectPanelField');

    return {
        NO_CLIENTS_FOUND: t('noClientsFound'),
        SEARCH: t('search')
    };
};

export default useTranslation;
